import React, { Component } from 'react';

export class IsPossible extends Component {
	render() {
		return (
			<div id='about'>
				<div className='container'>
					<div className='row'>
						{/* TODO */}
						<div className='col-xs-12 col-md-6'>
							{' '}
							<div
								className='modal fade'
								id='modal1'
								tabIndex={-1}
								role='dialog'
								aria-labelledby='myModalLabel'
								aria-hidden='true'
							>
								<div className='modal-dialog modal-lg' role='document'>
									<div className='modal-content'>
										<div className='modal-body mb-0 p-0'>
											<div className='embed-responsive embed-responsive-16by9 z-depth-1-half'>
												<iframe
													title='videoCursoDemoFrame'
													className='embed-responsive-item'
													src='https://www.youtube.com/embed/9eSew4T0EDA'
													allowFullScreen
												/>
											</div>
										</div>
										<div className='modal-footer justify-content-center'>
											<span className='mr-4'>Spread the word!</span>

											<button
												type='button'
												className='btn btn-outline-primary btn-rounded btn-md ml-4'
												data-dismiss='modal'
											>
												Close
											</button>
										</div>
									</div>
								</div>
							</div>
							<h3>
								Da click sobre la imagen y veras un video de lo que podemos
								lograr juntos
							</h3>
							<img
								className='img-fluid z-depth-1'
								src='img/about.jpg'
								alt='video'
								data-toggle='modal'
								data-target='#modal1'
							/>
							<h2>
								Quedate en casa o en tu oficina, nosotros via online te
								capacitamos.
							</h2>
							<iframe
								title='face'
								src='https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fgrupotecnologicoaglae%2Fvideos%2F325468571858458%2F&show_text=1&width=560'
								width={560}
								height={661}
								style={{ border: 'none', overflow: 'hidden' }}
								scrolling='no'
								frameBorder={0}
								allowTransparency='true'
								allow='encrypted-media'
								allowFullScreen='true'
							/>
							;
						</div>

						<div className='col-xs-12 col-md-6'>
							<div className='about-text'>
								<h2>
									Realmente es posible hacer que mi trabajo que hago en horas ,
									lo puedo optimizar y hacer en segundos?
								</h2>
								<p>
									{this.props.data ? this.props.data.paragraph : 'loading...'}
								</p>
								<h3>Existen evidencias de que es posible ?</h3>
								<div className='list-style'>
									<div className='col-lg-6 col-sm-6 col-xs-12'>
										<ul>
											{this.props.data
												? this.props.data.Why.map((d, i) => (
														<li key={`${d}-${i}`}>{d}</li>
												  ))
												: 'loading'}
										</ul>
									</div>
									<div className='col-lg-6 col-sm-6 col-xs-12'>
										<ul>
											{this.props.data
												? this.props.data.Why2.map((d, i) => (
														<li key={`${d}-${i}`}> {d}</li>
												  ))
												: 'loading'}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default IsPossible;
